import { useEffect, useState } from "react";

type ErrorHelpers<T> = {
  setItems: (items: T[]) => void;
  setLoading: (loading: boolean) => void;
};

type UseApiListOptions<T> = {
  request: () => Promise<{ data: any }>;
  mapData: (data: any) => T[];
  deps?: unknown[];
  onError?: (error: unknown, helpers: ErrorHelpers<T>) => void;
  initialLoading?: boolean;
};

export const useApiList = <T>({
  request,
  mapData,
  deps = [],
  onError,
  initialLoading = true,
}: UseApiListOptions<T>) => {
  const [items, setItems] = useState<T[]>([]);
  const [loading, setLoading] = useState<boolean>(initialLoading);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    request()
      .then((response) => {
        if (!isMounted) {
          return;
        }
        setItems(mapData(response.data));
        setLoading(false);
      })
      .catch((error) => {
        if (!isMounted) {
          return;
        }
        if (onError) {
          onError(error, { setItems, setLoading });
        } else {
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, deps);

  return { items, loading };
};
